export const useFoodIcon = (foodType: string | null = null): string | null => {
  if (!foodType) return null;

  const foodTypeLower = foodType.toLowerCase();
  const foodMapping: Record<string, string> = {
    veg: '/icons/veg.png',
    egg: '/icons/egg.png',
    nonveg: '/icons/nonveg.png',
    non_veg: '/icons/nonveg.png'
  };

  return foodMapping[foodTypeLower] || null;
};
